<template lang="pug">
.history
  HScroll(:currentStep='currentStep')
    transition(name='simple-fade' mode='out-in')
      //- STEP 1 (always visible)
      CustomerChooser(v-model='customer' @input='setCurrentStep(STEP_SELECT_CUSTOMER)')

    transition(name='simple-fade' mode='out-in')
      //- STEP 2 (visible if customer is selected)
      .d-flex.p-0(v-if='customer')
        CustomerInsight(
          :data='customer'
        )
          //- :customerId='customer.id'
        ActionSelectorMenu(:items='actionItems' v-model='actionType')

    transition(name='simple-fade' mode='out-in')
      //- STEP 3 (visible if actionType is selected)
      div(v-if='actionType')
        template(v-if='actionType === "SELL_LIST"')
          SellList(
            :customer='customer'
            v-model='preSelectedSellRecord'
          )
        template(v-else-if='actionType === "OUTSTANDING_LIST"')
          OutstandingList(:customer='customer')
        template(v-else-if='actionType === "BESTSELLINGS_LIST"')
          BestSellingsList(:customer='customer')
        template(v-else-if='actionType === "BACKORDER_LIST"')
          BackOrderList(:customer='customer')
        template(v-else-if='actionType === "QUOTATION_LIST"')
          QuotationList(:customer='customer')
        template(v-else-if='actionType === "PRODUCT_PURCHASE_LIST"')
          ProductPurchaseHistory(:customer='customer')
        template(v-else-if='actionType === "CHECK_IN"')
          ActionSelectorMenu(:items='checkinActionItems' v-model='checkinActionType')

        template(v-else)
          GenericCard.actionDetail(size='33')
            .d-flex.flex-column.px-3.py-4
              h5 {{ actionType }}

    transition(name='simple-fade' mode='out-in')
      //- STEP 4 (visible if checkinActionType is selected)
      div(v-if='checkinActionType')
        template(v-if='checkinActionType === "LOCATION"')
          Location(:customer='customer')
        template(v-else-if='checkinActionType === "CHECK_IN"')
          CheckIn(:customer='customer')
        template(v-else-if='checkinActionType === "VISIT_LOG"')
          VisitLog(:customer='customer')

        template(v-else)
          GenericCard.actionDetail(size='33')
            .d-flex.flex-column.px-3.py-4
              h5 {{ checkinActionType }}

</template>

<script>
import CustomerChooser from '@/components/customers/CustomerChooser.vue';
import CustomerInsight from '@/components/customers/CustomerInsight.vue';
import SellList from '@/components/history/panels/SellList.vue';
import OutstandingList from '@/components/history/panels/OutstandingList.vue';
import BestSellingsList from '@/components/history/panels/BestSellingsList.vue';
import BackOrderList from '@/components/history/panels/BackOrderList.vue';
import QuotationList from '@/components/history/panels/QuotationList.vue';

import ProductPurchaseHistory from '@/components/_cs/customer-history/panels/ProductPurchaseHistory.vue';

import Location from '@/components/history/checkin/Location.vue';
import CheckIn from '@/components/history/checkin/CheckIn.vue';
import VisitLog from '@/components/history/checkin/VisitLog.vue';

export default {
  data: () => ({
    customer: null,
    actionType: null,
    checkinActionType: null,
    // actionDetail: null,
    currentStep: 0,

    filterProvince: '',

    STEP_SELECT_CUSTOMER: 1,
    STEP_SELECT_ACTION: 2,
    STEP_SELECT_CHECKIN_ACTION: 3,

    actionItems: {
      SELL_LIST: 'ดูสถานะรายการขาย',
      OUTSTANDING_LIST: 'ดูรายการค้างชำระ',
      BESTSELLINGS_LIST: 'ดูรายการสินค้าขายดี',
      BACKORDER_LIST: 'ดูรายการ Back Order',
      QUOTATION_LIST: 'ดูรายการใบเสนอราคา',
      PRODUCT_PURCHASE_LIST: 'ดูประวัติสินค้าที่ซื้อ',
      CHECK_IN: 'Check in เยี่ยมลูกค้า',
    },

    checkinActionItems: {
      LOCATION: 'ที่อยู่ปัจจุบัน',
      CHECK_IN: 'Check in',
      VISIT_LOG: 'ดูประวัติการเยี่ยม',
    },

    preSelectedSellRecord: null,
  }),
  watch: {
    actionType(newVal) {
      if (newVal) {
        this.setCurrentStep(this.STEP_SELECT_ACTION);
      }
    },
    checkinActionType(newVal) {
      if (newVal) {
        this.setCurrentStep(this.STEP_SELECT_CHECKIN_ACTION);
      }
    },
  },
  computed: {
    isActionDetailsValid() {
      return this.receiptType !== -1
          && this.deliveryType !== -1
          && this.shipmentMethod !== -1;
    },
  },
  methods: {
    setCurrentStep(step) {
      // change step to step - 1 => wait 50ms => change step to the actual value
      // so the change is always noticed by the HSrcoll component
      // HSroll will then scoll to the right, so the new view is visible to the user
      this.currentStep = step - 1;
      setTimeout(() => {
        this.currentStep = step;

        //
        // 1. PREPARE the data for each STEP
        // 2. RESET the data gathered from further steps
        //    so the data won't be mixed up
        //

        // STEP 1
        if (step < this.STEP_SELECT_CUSTOMER) {
          // ..
          this.customer = null;
        }

        // STEP 2
        if (step < this.STEP_SELECT_ACTION) {
          this.actionType = null;
        }

        // STEP 3
        if (step < this.STEP_SELECT_CHECKIN_ACTION) {
          this.checkinActionType = null;
        }
      }, 50);
    },
  },
  async mounted() {
    const { sellRecord } = this.$route.params;

    // If the sellRecord data is provided, take the user right to the Modal
    if (sellRecord) {
      console.log(sellRecord);

      // 1. Select customer
      this.customer = sellRecord.customer;

      // 2. Select action
      if (sellRecord.status === this.$api.order.ORDER_STATUS.QUOTATION) this.actionType = 'QUOTATION_LIST';
      else this.actionType = 'SELL_LIST';

      // 3. Select the sellRecord
      this.preSelectedSellRecord = sellRecord;
    }

    // fetch notifications & kept in store
    await this.$api.notification.list();
  },
  components: {
    CustomerChooser,
    CustomerInsight,
    SellList,
    OutstandingList,
    BestSellingsList,
    BackOrderList,
    QuotationList,

    ProductPurchaseHistory,

    Location,
    CheckIn,
    VisitLog,
  },
};
</script>

<style lang="scss">
.history {
  > .h-scroll {
    height: 100%;
  }
}
</style>
